(function () {
  if (window.twdVideoStories) { return; }
  window.twdVideoStories = true;

  var state = {
    sources: [],
    index: 0,
    muted: false,
    modal: null,
    video: null,
    bars: null,
    muteBtn: null,
    opener: null,
    preview: null,
    previewWasPlaying: false,
    startX: 0,
    startY: 0
  };

  function el(tag, cls, attrs) {
    var node = document.createElement(tag);
    if (cls) { node.className = cls; }
    if (attrs) {
      Object.keys(attrs).forEach(function (key) { node.setAttribute(key, attrs[key]); });
    }
    return node;
  }

  function safePlay(video) {
    if (!video) { return; }
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') { attempt.catch(function () {}); }
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function updateMuteLabel() {
    state.muteBtn.textContent = state.muted ? 'Sound off' : 'Sound on';
    state.muteBtn.setAttribute('aria-pressed', state.muted ? 'true' : 'false');
  }

  function updateBars() {
    var fills = state.bars.querySelectorAll('.twd-vs-modal__fill');
    var duration = state.video.duration;
    var pct = duration ? (state.video.currentTime / duration) * 100 : 0;
    Array.prototype.forEach.call(fills, function (fill, i) {
      var width = i < state.index ? 100 : (i === state.index ? pct : 0);
      fill.style.width = width + '%';
    });
  }

  function play(index) {
    if (index < 0) { index = 0; }
    if (index >= state.sources.length) { closeModal(); return; }
    state.index = index;
    state.video.src = state.sources[index];
    state.video.muted = state.muted;
    updateBars();
    safePlay(state.video);
  }

  function buildModal() {
    if (state.modal) { return; }
    var modal = el('div', 'twd-vs-modal', { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Customer videos' });
    modal.hidden = true;

    var bars = el('div', 'twd-vs-modal__bars');
    var video = el('video', 'twd-vs-modal__video', { playsinline: '', 'webkit-playsinline': '' });
    video.playsInline = true;

    var closeBtn = el('button', 'twd-vs-modal__btn twd-vs-modal__close', { type: 'button', 'aria-label': 'Close video' });
    closeBtn.textContent = String.fromCharCode(215);
    var muteBtn = el('button', 'twd-vs-modal__btn twd-vs-modal__mute', { type: 'button' });
    var prevBtn = el('button', 'twd-vs-modal__nav twd-vs-modal__nav--prev', { type: 'button', 'aria-label': 'Previous video' });
    prevBtn.textContent = String.fromCharCode(8249);
    var nextBtn = el('button', 'twd-vs-modal__nav twd-vs-modal__nav--next', { type: 'button', 'aria-label': 'Next video' });
    nextBtn.textContent = String.fromCharCode(8250);

    [bars, video, closeBtn, muteBtn, prevBtn, nextBtn].forEach(function (node) { modal.appendChild(node); });
    document.body.appendChild(modal);

    state.modal = modal;
    state.video = video;
    state.bars = bars;
    state.muteBtn = muteBtn;

    closeBtn.addEventListener('click', closeModal);
    prevBtn.addEventListener('click', function () { play(state.index - 1); });
    nextBtn.addEventListener('click', function () { play(state.index + 1); });
    muteBtn.addEventListener('click', function () {
      state.muted = !state.muted;
      state.video.muted = state.muted;
      updateMuteLabel();
    });
    video.addEventListener('click', function () {
      if (video.paused) { safePlay(video); } else { video.pause(); }
    });
    video.addEventListener('timeupdate', updateBars);
    video.addEventListener('ended', function () { play(state.index + 1); });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) { closeModal(); }
    });
    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closeModal(); }
      else if (event.key === 'ArrowRight') { play(state.index + 1); }
      else if (event.key === 'ArrowLeft') { play(state.index - 1); }
    });
    modal.addEventListener('touchstart', function (event) {
      var touch = event.changedTouches[0];
      state.startX = touch.clientX;
      state.startY = touch.clientY;
    }, { passive: true });
    modal.addEventListener('touchend', function (event) {
      var touch = event.changedTouches[0];
      var dx = touch.clientX - state.startX;
      var dy = touch.clientY - state.startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        play(dx < 0 ? state.index + 1 : state.index - 1);
      } else if (dy > 90 && dy > Math.abs(dx)) {
        closeModal();
      }
    }, { passive: true });
  }

  function openModal(root, index, opener) {
    buildModal();
    var items = root.querySelectorAll('.twd-vs__item');
    state.sources = Array.prototype.map.call(items, function (item) { return item.getAttribute('data-src'); });
    state.bars.innerHTML = '';
    state.sources.forEach(function () {
      var bar = el('div', 'twd-vs-modal__bar');
      bar.appendChild(el('span', 'twd-vs-modal__fill'));
      state.bars.appendChild(bar);
    });
    state.opener = opener;
    state.preview = root.querySelector('.twd-vs__item.is-live video');
    state.previewWasPlaying = !!(state.preview && !state.preview.paused);
    if (state.preview) { state.preview.pause(); }
    updateMuteLabel();
    state.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    play(index);
    state.modal.querySelector('.twd-vs-modal__close').focus();
  }

  function closeModal() {
    if (!state.modal || state.modal.hidden) { return; }
    state.video.pause();
    state.video.removeAttribute('src');
    state.video.load();
    state.modal.hidden = true;
    document.body.style.overflow = '';
    if (state.preview && state.previewWasPlaying && !prefersReducedMotion()) { safePlay(state.preview); }
    if (state.opener && state.opener.focus) { state.opener.focus(); }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var item = target && target.closest ? target.closest('.twd-vs__item') : null;
    if (!item) { return; }
    var root = item.closest('[data-twd-vs]');
    if (!root) { return; }
    var items = Array.prototype.slice.call(root.querySelectorAll('.twd-vs__item'));
    openModal(root, items.indexOf(item), item);
  });

  function initPreviews() {
    var previews = document.querySelectorAll('[data-twd-vs] .twd-vs__item.is-live video');
    Array.prototype.forEach.call(previews, function (video) {
      if (video.getAttribute('data-vs-ready') === 'true') { return; }
      video.setAttribute('data-vs-ready', 'true');
      video.muted = true;
      if (prefersReducedMotion()) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      safePlay(video);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (state.modal && !state.modal.hidden) { return; }
            if (entry.isIntersecting) { safePlay(video); } else { video.pause(); }
          });
        }, { threshold: 0.25 }).observe(video);
      }
    });
  }

  function loadLazy(video) {
    var src = video.getAttribute('data-lazy-src');
    if (!src) { return; }
    video.removeAttribute('data-lazy-src');
    video.setAttribute('preload', 'metadata');
    video.src = src;
    video.load();
  }

  function armLazyRow(root, row, videos) {
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          cardObserver.unobserve(entry.target);
          loadLazy(entry.target);
        }
      });
    }, { root: row, rootMargin: '0px 400px 0px 400px' });
    Array.prototype.forEach.call(videos, function (video) { cardObserver.observe(video); });
  }

  function initLazy() {
    var roots = document.querySelectorAll('[data-twd-vs]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-vs-lazy') === 'true') { return; }
      root.setAttribute('data-vs-lazy', 'true');
      var videos = root.querySelectorAll('video[data-lazy-src]');
      if (!videos.length) { return; }
      var row = root.querySelector('.twd-vs__row');
      if (!('IntersectionObserver' in window) || !row) {
        Array.prototype.forEach.call(videos, loadLazy);
        return;
      }
      var sectionObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          sectionObserver.disconnect();
          armLazyRow(root, row, videos);
        }
      }, { rootMargin: '300px 0px 300px 0px' });
      sectionObserver.observe(root);
    });
  }

  function init() {
    initPreviews();
    initLazy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
